export default {
  adjustFolderShares: 'adjust folder shares',
  addPublishedFolder: 'add published folder',
  createFolder: 'create folder',
  deleteFolder: 'delete folder',
  deleteFolderItem: 'delete folder item',
  removeFolderShares: 'remove folder shares',
  removePublishedFolder: 'remove published folder',
  setCurrentFolderId: 'set current folder ID',
  setFolders: 'set folders',
  setNewPublished: 'set new published',
  setNewShared: 'set new shared',
  sortAscending: 'sort ascending',
  sortDescending: 'sort descending',
  sortManual: 'sort manual',
  sortSharedAscending: 'sort shared ascending',
  sortSharedAuthor: 'sort shared author',
  sortSharedDate: 'sort shared date',
  sortSharedDescending: 'sort shared descending',
  updateChangedFolders: 'update changed folders',
  updateFolder: 'update folder',
}
